import { api } from "./api";

const actions = {
	mapsSearchText: (query, data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			const encodedQuery = encodeURIComponent(query);
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/google/search/${encodedQuery}`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Get google place details by google place ID */
	getGooglePlaceByID: (googleID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			const encodedGoogleID = encodeURIComponent(googleID);
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/google/places/${encodedGoogleID}`,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
